import { TextField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventTypeRequirement } from "../../types/eventType";
import { CountrySelectField } from "../../ui/CountrySelectField";
import { EventFormColumns } from "./EventFormColumns";
import { useEventTypeField } from "./useEventTypeField";

export const EventAddressStepFormFields: FC = () => {
	const eventType = useEventTypeField();

	return (
		<EventFormColumns>
			{eventType && <AddressInput addressRequirement={eventType.addressRequirement} />}
		</EventFormColumns>
	);
};

const AddressFormFields: FC<{ isAddressRequired: boolean }> = ({ isAddressRequired }) => {
	const { t } = useTranslation();

	return (
		<>
			<TextField name="address.additionalInfo" label={t("Additional address info")} />
			<TextField name="address.street" label={t("Street")} required={isAddressRequired} />
			<TextField name="address.houseNumber" label={t("houseNumber")} required={isAddressRequired} />
			<TextField name="address.zip" label={t("Zip")} required={isAddressRequired} />
			<TextField name="address.city" label={t("City")} required={isAddressRequired} />
			<CountrySelectField name="address.country" label={t("Country")} required={isAddressRequired} clearable={true} />
		</>
	);
};

const AddressInput: FC<{ addressRequirement: EventTypeRequirement }> = ({ addressRequirement }) => {
	return (
		<>
			{addressRequirement === "required" && <AddressFormFields isAddressRequired={true} />}
			{addressRequirement === "optional" && <AddressFormFields isAddressRequired={false} />}
		</>
	);
};
